import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const auditlog = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
export default auditlog;
